import { useEffect, useState } from "react";

import { observePresence, startPresence } from "../data/presenceRepository";
import { remoteFailure, remoteSuccess } from "../data/remoteState";
import type { PresenceModel, RemoteState } from "../shared/types/contracts";

const CLIENT_ID_KEY = "ds:clientId";

export function getClientId(): string {
  try {
    let id = sessionStorage.getItem(CLIENT_ID_KEY);
    if (!id) {
      id = crypto.randomUUID();
      sessionStorage.setItem(CLIENT_ID_KEY, id);
    }
    return id;
  } catch {
    return crypto.randomUUID();
  }
}

export function usePresenceWriter(
  teamId: string | null | undefined,
  uid: string | null | undefined,
): void {
  useEffect(() => {
    if (!teamId || !uid) return undefined;
    return startPresence(teamId, uid, getClientId());
  }, [teamId, uid]);
}

export function usePresenceList(
  teamId: string | null | undefined,
): RemoteState<PresenceModel[]> {
  const [state, setState] = useState<RemoteState<PresenceModel[]>>(() =>
    remoteSuccess([]),
  );
  useEffect(() => {
    if (!teamId) {
      setState(remoteSuccess([]));
      return undefined;
    }
    return observePresence(
      teamId,
      (docs) => setState(remoteSuccess(docs)),
      (error) => setState(remoteFailure(error)),
    );
  }, [teamId]);
  return state;
}
